import React from "react";
import { ModalComponent, ModalTemplate } from "../reusableComponent";
import { isValidArray } from "../../helper";
import { Link } from "react-router-dom";
import { PATHS } from "../../constant";

export function ChildIssuePopUp({ childIssues, show, onClose }) {
  return (
    (isValidArray(childIssues) && show && (
      <ModalComponent
        onClose={onClose}
        centered={true}
        containerClass="child-issue-pop-up"
        template={
          <ModalTemplate
            bodyTemplate={
              <section class="text-center">
                <h5>
                  Please resolve/reject the child issue(s) before changing the
                  recipient of the issue.
                </h5>
                <h5>
                  Child Issue Id(s): -{" "}
                  {childIssues.map((val, index) => (
                    <Link
                      to={{
                        pathname: PATHS.ISSUE_DETAIL,
                        search: `?issueId=${val.issueId}&&projectId=${
                          val.projectId
                        }`
                      }}
                    >
                      {`${val.issueId}${
                        index < childIssues.length - 1 ? ", " : ""
                      }`}
                    </Link>
                  ))}
                </h5>
              </section>
            }
            footerDisplay={false}
          />
        }
      />
    )) ||
    null
  );
}
